import { Box, Button, Heading, Image, Text } from '@chakra-ui/react';
import { ROUTE_DASHBOARD_BOOKING_PAGE_HELPER } from '@/constants/routes';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import imPlaceholder from './guide_es.png';

interface IProps {}

export default function NoServicesBanner(props: IProps) {
	const { t } = useTranslation();

	return (
		<Box display="flex" flexDir="column" p="4" h="100%">
			<Heading textAlign="center" size="lg">
				{t('You have no services yet.')}
			</Heading>

			<Text
				mt={4}
				textAlign={{
					base: 'left',
					md: 'center',
				}}
			>
				{t('Services are web pages where people can see your availability and book events with you.')}
			</Text>

			<Image mt={8} src={imPlaceholder} />

			<Button mt="auto" as={Link} to={ROUTE_DASHBOARD_BOOKING_PAGE_HELPER} colorScheme="primary" w="100%">
				{t('Create a new service')}
			</Button>
		</Box>
	);
}
